<smvd-ui-match-star-score
    *ngIf="(meta?.total | greaterThan: 0) || (!meta?.externalTotal && showDefault); else externalScore"
    [meta]="meta"
></smvd-ui-match-star-score>

<ng-template #externalScore>
    <smvd-match-external-score *ngIf="meta?.externalTotal | greaterThan: 0" [meta]="meta"></smvd-match-external-score>
</ng-template>
